<template>
    <div class="positionRelative">
        <LoadingOverlay v-if="isLoading"></LoadingOverlay>
                                

        <main class="main-form-area multi-step-body step-forward">
            <div class="form-step ng-scope">
                <div class="page summary">
                    <h2>{{ __('page_confirm.pagetitle') }}</h2>

                    <form name="payment" class="form-horizontal container" novalidate="" action="#" onsubmit="return false;">

                    <!-- left -->
            <div class="containerConfirm">
                <div class="left-section">
                    <table>
                        <tr>
                            <td>
                                <h4 class="payment_confirm_col1 confirmationTitle">{{ __('page_setcontact.pagetitle') }}</h4>
                            </td>
                            <td >
                                <div>
                                    <dl class="form">
                                        <dd class="">
                                            {{registration.company.name}}
                                        </dd>
                                        <dd class="">
                                            {{registration.company.street1}}
                                        </dd>
                                        <dd v-if="registration.company.street2" class="">
                                            {{registration.company.street2}}
                                        </dd>
                                        <dd class="">
                                            {{registration.company.zip}} {{registration.company.city}}
                                        </dd>
                                        <dd class="">
                                            {{getCountryNameByCode(registration.company.country)}}
                                        </dd>
                                        <dd v-if="registration.company.vatid" class=" ">
                                            {{registration.company.vatid}}
                                        </dd>
                                        <dd v-if="registration.vouchercode"
                                            class=" ">
                                            {{registration.vouchercode}}
                                        </dd>
                                        <dd v-if="registration.company.url_company"
                                            class=" ">
                                            {{registration.company.url_company}}
                                        </dd>
                                    </dl>
                                </div>
                            </td>
                        </tr>
                    </table>
                    <!--end left-->

                </div>        
                        <!-- right -->
                    <div class="right-section">
                        <div class="col-xl-3">
                            <div class="payment_confirm_col1 flex">
                                <h4 class="confirmationTitle">{{ __('page_setcontact.contact_header') }}</h4>
                                <div class="payment_confirm_col2">
                                <dl class="form" style="width: max-content;">
                                    <dd>
                                        {{getSalutation(registration.contact.salutation)}}
                                        {{registration.contact.firstname}}
                                        {{registration.contact.lastname}}
                                    </dd>
                                    <dd>
                                        {{registration.contact.email}}
                                    </dd>
                                    <dd>
                                        <span >{{ __('page_setcontact.phone') }}</span>
                                        {{registration.contact.phone}}
                                    </dd>
                                    <dd v-if="registration.contact.fax">
                                        <span>{{ __('page_setcontact.fax') }}</span> {{registration.contact.fax}}
                                    </dd>
                                    <dd>
                                        <span v-if="registration.createUserAccount" style="font-style: italic">
                                            {{ __('page_setcontact.createaccount') }}
                                        </span>
                                    </dd>
                                </dl>
                            </div>
                            </div>
                        </div>
                    </div>

                </div>
             
                
                
                <!-- end right-->
                <h4 v-if="registration.company.po_number" class="payment_confirm_col1 confirmationTitle pt-6">{{ __('page_setcontact.ponumber') }}</h4>
                <div v-if="registration.company.po_number" class="payment_confirm_col2">
                    <dl class="form">
                        <dd class="">
                            {{registration.company.po_number}}
                        </dd>    
                    <br>
                    </dl>
                </div>
                
                <br>

                <h4 v-if="registration.company.master_brewer" class="payment_confirm_col1 confirmationTitle pt-6">{{ __('page_setcontact.masterbrewer_header') }}</h4>
                <div v-if="registration.company.master_brewer" class="payment_confirm_col2" >
                    <dl class="form">
                        <dd class="">
                            {{registration.company.master_brewer}}
                        </dd>    
                    <br>
                    </dl>
                </div>    

                    <div class="clear"></div>
                    <div class="payment_confirm_col1 confirmationTitle" v-if="registration.hasDeputy">
                        <h4>{{ __('page_setcontact.deputy_header') }}</h4>
                        </div>
                        <div class="payment_confirm_col2" v-if="registration.hasDeputy">
                            <dl class="form">
                                <dd class="">
                                    {{getSalutation(registration.deputy.salutation)}} {{registration.deputy.firstname}}
                                    {{registration.deputy.lastname}}
                                </dd>
                                <dd class="">
                                    {{registration.deputy.email}}
                                </dd>
                                <dd class="">
                                    <span class="">{{ __('page_setcontact.phone') }}</span>
                                    {{registration.deputy.phone}}
                                </dd>
                                <dd v-if="registration.deputy.fax">
                                    <span>{{ __('page_setcontact.fax') }}</span> {{registration.contact.fax}}
                                </dd>
                            </dl>
                        </div>
                        <div class="clear"></div>

                        <div v-if="priceInfo" style="width:100%;  margin-bottom: 1em;" class="light">
                            <h4>
                                {{ __('page_setcontact.vouchercode') }}
                            </h4>

                            <div style="display: flex; align-items: center;">
                                <span>
                                    {{ __('page_setcontact.vouchercodeText') }}
                                </span>
                                <div style="display: flex; align-items: center; margin-left: auto;">
                                    <input style="margin-right: 10px; width: 300px;" type="text" class="XL inputText" v-model="vouchercode" :disabled="!voucherCodeFailed && voucherCodeFailed !== null"/>
                                    <button class="buttonSubmit" type="button" :disabled="!voucherCodeFailed && voucherCodeFailed !== null" @click="applyVoucherCode">
                                        {{ __('page_setcontact.vouchercode') }}
                                    </button>
                                    <div v-if="!voucherCodeFailed && voucherCodeFailed !== null" style="display: inline-block;">  
                                        <button id="restore-button" @click="restoreVoucher">
                                            <span>x</span>
                                        </button> 
                                    </div>
                                </div>
                            </div>

                           
                            <div style="text-align: right; padding-top: 20px;" class="wglErrorMessage voucherMessage--loading-error" v-if="voucherCodeFailed && voucherCodeFailed !== null">
                                {{ __('page_confirm.vouchercode_error') }}
                            </div>
                            <div style="text-align: right; padding-top: 20px; color: green;" class="wglErrorMessage voucherMessage--loading-success" v-if="!voucherCodeFailed && voucherCodeFailed !== null">
                                {{ __('page_confirm.vouchercode_valid') }}
                            </div>
                        </div>

                        <h4 style="display: inline-block;">{{ __('page_confirm.beers') }}</h4>
                       
                        <table class="light" v-if="priceInfo">
                            <thead class="table-head">
                                    <tr>
                                        <th style="min-width: 175px;">
                                            {{ __('page_setbeers.category') }}
                                        </th>
                                        <th style="min-width: 175px;" class="">{{ __('page_setbeers.nameofbeer') }}</th>
                                        <th style="min-width: 80px;">
                                            {{ __('page_setbeers.alcvol') }}
                                        </th>
                                        <th style="min-width: 175px;">{{ __('page_setbeers.wortvol') }}</th>
                                        <th style="min-width: 80px; text-align: right;">
                                            <span v-if="!priceInfo.noprices">
                                                {{ __('page_confirm.price_net') }}
                                            </span>
                                        </th>
                                    </tr>
                            </thead>
                            <tbody>
                            <!-- ngRepeat: beer in data.beers -->
                            <tr v-for="(beer, index) in registration.beers" :key="index"
                                style="padding-bottom: 1em;">
                                <td>
                                    <span>{{getCategoryNameById(beer.category)}}</span>
                                </td>
                                <td>{{beer.name}}</td>
                                <td style="text-align: left">{{formatAlcVol(beer.alcVol)}} %</td>
                                <td style="text-align: left">{{formatWortVol(beer.wortVol)}} °P</td>
                                <td style="text-align: right; padding-right: 10px;">
                                    <span v-if="!priceInfo.noprices">{{ formatPrice(priceInfo.prices[index].net) }}</span>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot v-if="!priceInfo.noprices">
                                <tr style="text-align: right">
                                    <th colspan="3"></th>
                                    <th style="text-align: left" class="fontWunderlich">
                                        {{ __('page_confirm.total_net') }}
                                    </th>
                                    <th style="text-align: right;">{{ formatPrice(getTotalPriceNetto) }}</th>
                                </tr>
                                <tr style="text-align: right">
                                    <th colspan="3"></th>
                                    <th style="text-align: left; font-weight: normal;">
                                        {{ __('page_confirm.total_vat_hint', [priceInfo.tax]) }}
                                    </th>
                                    <th style="text-align: right; font-weight: normal;">
                                        {{ formatPrice(getTotalPriceNetto * priceInfo.tax / 100) }}
                                    </th>
                                </tr>
                                <tr style="text-align: right">
                                    <th colspan="3"></th>
                                    <th style="text-align: left" class="fontWunderlich"><b>{{ __('page_confirm.total') }}</b>
                                    </th>
                                    <th style="text-align: right;">{{ formatPrice(getTotalPriceNetto * (1 + priceInfo.tax /
                                        100)) }}
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                        
                        <!-- Future award -->
                        <table class="light" v-if="priceInfo">
                            <thead class="table-head">
                                    <tr>
                                        <th style="min-width: 175px;">
                                            <h4>{{ __('page_confirm.future_award') }}</h4>
                                        </th>
                                    </tr>
                            </thead>
                            <tbody>

                            <tr style="padding-bottom: 1em;">
                                <td>
                                    <div style="margin-bottom: 1em; margin-top: 30px; margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
                                        <label>{{ __('page_setcontact.enter_futureaward_1') }}
                                            <a v-if="$store.language === 'de'" target="_blank" href="https://www.european-beer-star.de/ebs-de/wettbewerb/future-award/">"Future Award"</a>
                                            <a v-else target="_blank" href="https://www.european-beer-star.de/ebs-en/wettbewerb/future-award/">"Future Award"</a>
                                            {{ __('page_setcontact.enter_futureaward_2') }}
                                        </label>

                                        <div class="form-control flex justify-between items-center pl-2">
                                            <label for="toggleFutureAward" class="flex items-center justify-between w-full">
                                                <div class="text-gray-700 pr-2" style="white-space: nowrap;"></div>
                                                <div class="relative pr-4">
                                                    <input type="checkbox" id="toggleFutureAward" class="sr-only" v-model="company.future_award" :value="company.future_award=='1'" required>
                                                    <div class="block bg-gray-300 rounded-full w-14 h-7"></div>
                                                    <div style="margin-top: -26px;" class="absolute w-6 h-5 transition bg-white rounded-full dot" :class="{ 'left-1': company.future_award=='0', 'toggleButtonM': company.future_award=='1' }"></div>
                                                </div>
                                            </label>
                                        </div>

                                    </div>
                                    <div class="wglErrorMessage pb-4" v-if="company.future_award === null">
                                        {{ __('page_confirm.must_confirm_future_award') }}
                                    </div>

                                </td>
                            </tr>

                            </tbody>
                        </table>

                        <!-- Wettbewerbsbestimmungen -->
                        <table class="light" v-if="priceInfo">
                            <thead class="table-head">
                                    <tr>
                                        <th style="min-width: 175px;">{{ __('page_confirm.rules') }}</th>
                                    </tr>
                            </thead>
                                <tbody>
                                    
                                    <tr style="padding-bottom: 1em;">
                                        <td style="width: 100%;">
                                            <div style="margin-bottom: 1em; margin-top: 30px; margin-bottom: 20px;">
                                              <dd class="w-full form-control flex justify-between items-center">
                                                <label for="toggleDeputy" class="flex items-center justify-between w-full">
                                                    <div class="text-gray-700" style="white-space: nowrap;" v-html="__('page_confirm.page_acceptrules', null, true)"></div>
                                                    <div class="relative pr-4">
                                                        <input type="checkbox" id="toggleDeputy" class="sr-only" v-model="confirmRules" value="true">
                                                        <div class="block bg-gray-300 rounded-full w-14 h-7"></div>
                                                        <div style="margin-top: -26px;" class="absolute w-6 h-5 transition bg-white rounded-full dot" :class="{ 'left-1': !confirmRules, 'toggleButtonM': confirmRules }"></div>
                                                    </div>
                                                </label>
                                            </dd>
                                                <div style="padding-top: 10px;" class="wglErrorMessage" v-if="confirmRules === false">
                                                    {{ __('page_confirm.must_confirm_rules') }}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>


                            </tbody>
                        </table>

                        <h4 v-if="priceInfo && !priceInfo.noprices">{{ __('page_confirm.paymentmethod') }}</h4>

                        <div class="errorMessages" v-if="registrationFailed">
                            <ErrorMessage>{{ __('page_confirm.error') }}</ErrorMessage>
                            <ErrorMessage v-for="(error, index) in registrationErrors" :key="index">{{ error }}</ErrorMessage>
                        </div>
                        <!-- Paypal Button 2024 -->
                        <table id="full-paypal-container" class="light">
                            <thead class="table-head">
                                <tr>
                                    <th style="min-width: 250px;">
                                        <div id="title-paypal-creditcard"></div> 
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr> 
                                    <td>
                                        <div class="flex justify-center items-center h-[750px]">
                                            <div id="paypal-button-container" class="mt-8 paypal-container"></div>
                                            <div id="terms-condition-message" class="wglErrorMessage"></div>                                            
                                        </div>            
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        
                        <Accordion v-if="priceInfo && !priceInfo.noprices" class="accordion">
                            <AccordionTab :title="__('common.button_wiretransfer')"
                                          v-if="isPaymentMethodEnabled('provider_wire')"
                                          :active="activePaymentPanel === 2"
                                          @click="activePaymentPanel = 2">
                                <div>
                                            <span><p>
                                                {{ __('page_confirm.payment_wiretransfer') }}
                                            </p></span>
                                </div>
                                <div class="wglErrorMessage"
                                     v-if="!confirmRules">
                                    {{ __('page_confirm.must_confirm_rules') }}
                                </div>
                                <button class="buttonSubmit right " @click="doPayWire()"
                                        type="button"
                                        :disabled="!confirmRules">
                                    <span>{{ __('page_confirm.button_dopayment') }}</span>
                                </button>
                            </AccordionTab>
                        </Accordion>

                        <div class="flex flex-row justify-end w-full" v-else>
                            <button  type="button" class="buttonSubmit" @click="submit" :disabled="!confirmRules || company.future_award === null">
                            <span>{{__('page_confirm.sendregistration')}}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </main>
        <footer>
            <button class="btn-secondary left" type="button" @click="back">
                <span class="fa fa-backward"></span>
                <!-- eslint-disable-next-line vue/no-parsing-error -->
                <span>< {{ __('common.button_back') }}</span>
            </button>
        </footer>
    </div>
</template>

<script>
import {formatPercent} from "../utils/Format";
import _ from 'lodash';
import Api from '../api/Api'; // Importing Api
import Payment from "../api/Payment";
import Registration from "../api/Registration";
import Voucher from "../api/Voucher";
import LoadingOverlay from "../components/LoadingOverlay";
import Lang from "../mixins/Lang";
import Accordion from "../components/Accordion";
import AccordionTab from "../components/AccordionTab";
import ErrorMessage from "../components/ErrorMessage";
import store from '../store'
import { clientId as PAYPAL_CLIENT_ID_ENV } from '../api/PayPal.js';

export default {
        name: "Confirm",
        components: {ErrorMessage, AccordionTab, Accordion, LoadingOverlay},
        store: ['registration', 'currentView', 'categories',
            'language', 'countries', 'translations','paymentMethods',
        'additionalBeerCategoriesWithBeerType'],
        mixins: [Lang],

        created() {

            this.company = this.registration.company || this.company;
            this.vouchercode = this.registration.vouchercode || this.vouchercode;
            this.voucherCodeSaved = this.vouchercode;

            Payment.load(this.registration.beers.length, this.registration.company.country,
            this.registration.vouchercode, this.registration.company.vatid).then(({data}) => {
                this.isLoading = false;
                this.priceInfo = data;
            }).catch((e) => {
                alert(e.response && e.response.data
                    ? typeof e.response.data === 'object' ? e.response.data.join("\n") : e.response.data
                    : this.language === 'de' ? 'Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Eingaben oder versuchen Sie es später noch einmal' : 'An error occured. Please check your data or try again later.');
                this.back();
            });
        },

        methods: {
            categoryHasBeerType (categoryId) {
                let category = this.getCategoryById(categoryId);
                return category.ultrastrong || category.woodenbarrel ||
                    this.additionalBeerCategoriesWithBeerType.indexOf(categoryId) > -1;
            },

            back() {
                this.currentView = 'beers';
            },

            formatAlcVol(value) {
                return formatPercent(value);
            },

            formatWortVol(value) {
                return formatPercent(value);
            },

            isPaymentMethodEnabled(method) {
                return !!_.find(this.paymentMethods, (paymentMethod) => paymentMethod === method);
            },

            getSalutation(value) {
                if (value === 'm') {
                    return this.translations.common.salutation_male;
                } else {
                    return this.translations.common.salutation_female;
                }
            },

            getCountryNameByCode(code) {
                let country = _.find(this.countries, (country) => {
                    return country.val === code;
                });
                if (country) {
                    return country.label;
                } else {
                    return code;
                }
            },

            getCategoryById(id) {
                return _.find(this.categories, (category) => {
                    return category.id === id;
                });
            },

            getCategoryNameById(id) {
                let category = _.find(this.categories, (category) => {
                    return category.id === id;
                });
                if (this.language === 'de') {
                    return category.name_de;
                } else {
                    return category.name_en;
                }
            },

            submit() {

                this.registration.vouchercode = this.voucherCodeSaved;
                this.registration.company.future_award = this.company.future_award;
                this.isLoading = true;
                Registration.executeRegistration(this.registration, this.language, 'nobill').then((response) => {
                    if (response.status === 200 && response.data.success) {
                        this.registrationFailed = false;
                        this.currentView = 'complete';
                    } else {
                        this.registrationFailed = true;
                        if(response.data) this.registrationErrors = response.data.errors;

                    }
                    this.isLoading = false;
                }).catch(({response}) => {
                    this.registrationFailed = true;
                    this.isLoading = false;
                    if(response.data) this.registrationErrors = response.data.errors;
                });
            },

            doPayPaypal() {
                this.registration.vouchercode = this.voucherCodeSaved;
                this.registration.company.future_award = this.company.future_award;
                this.isLoading = true;
                Registration.executeRegistration(this.registration, this.language, 'provider_paypal').then((response) => {
                    
                    if (response.status === 200  && response.data.success) {
                        // Registration couldn't be executed.
                        if(!response.data.regid) {
                            this.registrationFailed = true;
                            return;
                        }

                        // Registration successful now we need to execute the PayPal.
                        // We have the PayPal information
                        console.log("The PayPal Configuration is: ", response.data.paymentConfig);
                        // return the paypal config

               
                    } else {
                        
                        this.registrationFailed = true;
                        this.isLoading = false;
                        if(response.data) this.registrationErrors = response.data.errors;
                    }
                }).catch(({response}) => {
                    this.registrationFailed = true;
                    this.isLoading = false;
                    if(response.data) this.registrationErrors = response.data.errors;
                });
            },

            doPayWire() {
                this.registration.vouchercode = this.voucherCodeSaved;
                this.registration.company.future_award = this.company.future_award;
                this.isLoading = true;
                Registration.executeRegistration(this.registration, this.language).then((response) => {
                    if (response.status === 200 && response.data.success) {
                        this.registrationFailed = false;
                        this.currentView = 'complete';
                    } else {
                        this.registrationFailed = true;
                        if(response.data) this.registrationErrors = response.data.errors;
                    }
                    this.isLoading = false;
                }).catch(({response}) => {
                    this.registrationFailed = true;
                    this.isLoading = false;
                    if(response.data) this.registrationErrors = response.data.errors;
                });
            },

            formatPrice(price) {
                const formatter = new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2
                });
                return formatter.format(price);
            },

            applyVoucherCode() {

                if(this.vouchercode == null || this.vouchercode == "") {
                    this.voucherCodeFailed = true;
                    return;
                }

                Voucher.check(this.vouchercode).then((response) => { 
                    
                    if (response.status === 200 && response.data.success) {
                        // Voucher Code exsits
                        this.voucherCodeFailed = false;
                        
                    } else {
                        // Voucher Code doens't exist
                        this.voucherCodeFailed = true;
                    }

                    Payment.load(this.registration.beers.length, this.registration.company.country,
                        this.vouchercode,this.registration.company.vatid).then(({data}) => {
                            // We save the previous status of vouchercode.
                            this.voucherCodeSaved = this.vouchercode;
                            this.isLoading = false;
                            this.priceInfo = data;
                        }).catch((e) => {
                            alert(e.response && e.response.data
                                ? typeof e.response.data === 'object' ? e.response.data.join("\n") : e.response.data
                                : this.language === 'de' ? 'Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Eingaben oder versuchen Sie es später noch einmal' : 'An error occured. Please check your data or try again later.');
                            this.back();
                        });


                    // eslint-disable-next-line no-unused-vars
                }).catch(({response}) => {

                });
            },

            restoreVoucher() {
                this.vouchercode = "";
                this.voucherCodeSaved = "";
                this.voucherCodeFailed = null;

                Payment.load(this.registration.beers.length, this.registration.company.country,
                        this.vouchercode, this.registration.company.vatid).then(({data}) => {
                            // We save the previous status of vouchercode.
                            this.voucherCodeSaved = this.vouchercode;
                            this.isLoading = false;
                            this.priceInfo = data;
                        }).catch((e) => {
                            alert(e.response && e.response.data
                                ? typeof e.response.data === 'object' ? e.response.data.join("\n") : e.response.data
                                : this.language === 'de' ? 'Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Eingaben oder versuchen Sie es später noch einmal' : 'An error occured. Please check your data or try again later.');
                            this.back();
                        });
            },

            /**
             * Method which setups and handles the PayPal || CreditCard payment.
             */
            setupMethodsPaypalButton: function () {

                var self = this;

                window.paypal
                    .Buttons({
                        // It defines the style of the paymeny methods.
                        style: {
                            layout: 'vertical',     // or 'horizontal'
                            shape: 'rect',          // or 'pill'
                            label: 'paypal',        // or 'checkout' or 'buynow' or 'pay' or 'installment'
                        },

                        createOrder: function (event) {
                            console.log('---- PayPal (createOrder): Creating order for PayPal / Credit Card...');

                            // We identify the payment provider executed on the PayPal SDK Buttons.
                            switch(event.paymentSource) {
                                case 'paypal': {
                                    return self.executeRegistrationAndCreateOrder('provider_paypal');
                                }

                                case 'card': {
                                    return self.executeRegistrationAndCreateOrder('provider_cc');
                                }
                            }
                            return self.executeRegistrationAndCreateOrder('provider_not_identified');
                        },
                        // onInit is called when the button first renders
                    onInit: function() {

                            console.log('Paypal oninit hiding paypal buttons');
                            if(!self.confirmRules) {
                                document.querySelector('#paypal-button-container').style.display = 'none';
                                document.querySelector('#terms-condition-message').style.display = 'block'; // show terms & condition     
                                const translatedAcceptTermsCondition = store.translations.page_confirm.must_confirm_rules; 
                                const translatedPaypalCreditcard = store.translations.page_confirm.paypal_creditcard; 
                                document.querySelector('#terms-condition-message').innerHTML = translatedAcceptTermsCondition;
                                document.querySelector('#title-paypal-creditcard').innerHTML = translatedPaypalCreditcard;                     
                            }
                    },

                    onApprove: function () {
                        console.log('---- PayPal (onApprove): Approving order with order id: ', self.paypalOrderId, ' regId: ', self.regIdAfterOrder, ' billId: ', self.billId);

                        const headers = { 'Content-Type': 'application/json' };
                        return Api.post('/payment/paypal/complete-order', { 
                            orderId: self.paypalOrderId, 
                            regId: self.regIdAfterOrder, 
                            billId: self.billId }, 
                            { headers: headers })

                            .then(function (res) {
                                console.log('Order approved, details:', res.data);
                                return res.data;
                            })

                            .then(function (details) {
                                if (details.status === 'success') {
                                    console.log('Order completed!', details.message);
                                    self.isLoading = false;
                                    self.registrationFailed = false;
                                    self.currentView = 'complete';
                                } else {
                                    self.registrationFailed = true;
                                    if (details.data) this.registrationErrors = details.data.errors;
                                    if (details.status === 'error') {
                                        console.error('Order failed:', details.message);
                                    } else {
                                        console.error('Unexpected response:', details);
                                    }
                                }
                            }.bind(this))

                            .catch(function (error) {
                                this.registrationFailed = true;
                                this.isLoading = false;
                                if (error.response && error.response.data) {
                                    this.registrationErrors = error.response.data.errors;
                                }
                                console.error('Error:', error);
                        }.bind(this));
                    },

                    onCancel: function () {
                        console.log('---- PayPal (onCancel): Client cancelled the payment: ');
                        this.isLoading = false;
                    }
                    .bind(this),

                    onError: function (err) {
                        console.log('---- PayPal (onError): An error occurred: ', err);
                        this.registrationFailed = true;
                        this.isLoading = false;
                        if (err.response && err.response.data) {
                            this.registrationErrors = err.response.data.errors;
                        }
                    }.bind(this)
                })
                .render("#paypal-button-container");
            },

            /**
             * Function which executes the online registration and gets the orderId from PayPal api in
             * order to start a paymeny ptocess.
             */
            executeRegistrationAndCreateOrder: function (paymentProvider) {

                console.log('---- PayPal (executeRegistrationAndCreateOrder)');
                this.registration.vouchercode = this.voucherCodeSaved;
                this.registration.company.future_award = this.company.future_award;
              //  this.isLoading = true;

                console.log('---- PayPal (executeRegistration)', this.registration, this.language, paymentProvider);
                return Registration.executeRegistration(this.registration, this.language, paymentProvider)
                    .then((response) => {

                        // PayPal Registration && orderId successful.
                        if (response.status === 200 && response.data.success) {
                            console.log('---- PayPal (Order Id )', response.data.paypalOrderId, " (Reg Id)", response.data.regId, " (Bill Id)", response.data.billId );
                            this.registration.createUserAccount = false;
                            this.paypalOrderId = response.data.paypalOrderId; // Store paypalOrderId in the Vue instance
                            this.regIdAfterOrder = response.data.regId;
                            this.billId = response.data.billId;
                            return response.data.paypalOrderId;

                        // PayPal not successful.
                        } else {
                            console.log('---- Registration/PayPal (NOT successful)', response.data.paypalOrderId);
                            this.registration.createUserAccount = false;
                            this.registrationFailed = true;
                            this.isLoading = false;
                            if (response.data) this.registrationErrors = response.data.errors;
                            throw new Error('Registration failed');
                        }
                    })
                    .catch(({ response }) => {
                        // executeRegistration isn't successful
                        this.registrationFailed = true;
                        this.isLoading = false;
                        if (response.data) this.registrationErrors = response.data.errors;
                        throw new Error('Registration failed'); // Relanzar el error para asegurarse de que se maneje aguas arriba
                    });
            },
        },

        computed: {
            getTotalPriceNetto() {
                let priceNetto = 0;
                if(!this.priceInfo) return 0;
                for (let index in this.registration.beers) {
                    priceNetto += this.priceInfo.prices[index].net;
                }
                return priceNetto;
            },
            shouldDisplayFullPaypalContainer() {
                return this.priceInfo && !this.priceInfo.noprices;
            },
        },

       

            data() {
            return {
                registrationFailed: null,
                voucherCodeFailed: null,
                registrationErrors : [],
                confirmRules: false,
                isOpened: true,
                voucherCodeSaved: "",
                itemDisabled: false,
                priceInfo: null,
                isLoading: true,
                registrationId: null,
                activePaymentPanel : 0,
                retries : 0
            }
        },
        watch: {
            shouldDisplayFullPaypalContainer(newValue) {
                let fullPaypalContainer = this.$el.querySelector('#full-paypal-container');
                fullPaypalContainer.style.display = newValue ? 'table' : 'none';
            },
            confirmRules(newValue) {
                let paypalButtonContainer = this.$el.querySelector('#paypal-button-container');
                let termsConditionMessage = this.$el.querySelector('#terms-condition-message');
                if (newValue == true) {
                    console.log("Confirm Rules displaying paypal buttons");
                    paypalButtonContainer.style.display = 'block';
                    termsConditionMessage.style.display = 'none';
                } else {
                    paypalButtonContainer.style.display = 'none';
                    termsConditionMessage.style.display = 'block';
                }
            },
        },
        mounted: function() {
            console.log("mounted: inititializing paypal button...");
            const clientId = PAYPAL_CLIENT_ID_ENV;
            const script = document.createElement("script");
                script.src = "https://www.paypal.com/sdk/js?client-id="+clientId+"&currency=EUR&disable-funding=sofort,venmo,sepa,p24,mybank,mercadopago,ideal,giropay,eps,blik,bancontact,paylater";
                script.addEventListener("load", this.setupMethodsPaypalButton);
                // script.addEventListener("load", () => { this.setLoaded });
                document.body.appendChild(script);
        },
    }

    
</script>

<style lang="scss">
    button.buttonReset.left {
        span {
            margin-left: 5px;
        }
    }

    .payment_confirm_col1, .payment_confirm_col2 {
        float: left;
        margin-bottom: 15px;
    }

    .payment_confirm_col1 {
        width: 20%;
    }

    .payment_confirm_col2 {
        width: 80%;
    }

    .clear {
        clear: both;
    }

    .container {
        display: flex;
        flex-wrap: wrap;
    }

    form input {
        width: auto;
    }

    .voucherMessage--loading {
        animation: loading 1s;
        animation-fill-mode: forwards;
    }

    @keyframes loading-success {
        from {
            color: black;
        }
        to {
            color: greenyellow;
        }
    }

     @keyframes loading-error{
        from {
            color: black;
        }
        to {
            color: greenyellow;
        }
    }

    button[disabled]{
        border-color: #8d8d8d;
        background-color: #e9e6e6;
        color: #8d8d8d;
        cursor: default;
    }

    button[disabled]:hover{
        border-color: #8d8d8d;
        background-color: #e9e6e6;
        color: #8d8d8d;
        cursor: default;
    }

    #restore-button {
        display: flex;
        justify-content: center;
        align-items: center;;
        padding: 0.5em;
        font-size: 18px;
        top: 0.5em;
        right: 0.5em;
        margin: 0;
        padding: 0;
        width: 25px;
        height: 25px;

    }
    .accordion{
        width: 100%
    }

    .cross-icon {
        font-weight: bold;
        font-size: 1.2em;
        color: #8d8d8d;
    }


    
</style>